export class FilterType {
    constructor(
        public title: FilterTypeTitle,
        public state?: FilterTypeState
    ) {}
}

export type FilterTypeTitle = 'Countries' | 'Categories' | 'Suppliers' | 'Brands' |
    'Attribute Types' | 'Attributes' | 'Retailer Types' | 'Retailers' |
    'Date Range' | 'Price' | 'Total SKU Size' | 'Promotions';

export type FilterTypeState = 'Default' | 'Custom';